import FormControlLabel from '@mui/material/FormControlLabel';
import { TextField } from '@mui/material';
import { IOSSwitch } from '../common/IosSwitch';
import Collapse from '@mui/material/Collapse';
import { useState } from 'react';
import { selectFirstOwnerInfo } from '../../redux-state/forms/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_FIRST_OWNER_INFO } from '../../redux-state/forms/types';

function FirstOwnerInformation() {
  const [isFieldVisible, setIsFieldVisible] = useState(false);
  const firstOwnerInfo = useSelector(selectFirstOwnerInfo);
  const dispatch = useDispatch();

  const handleChange = (key, value) => {
    dispatch({
      type: UPDATE_FIRST_OWNER_INFO,
      payload: { key, value },
    });
  };

  return (
    <div>
      <div className={`flex flex-row justify-between p-4 ${isFieldVisible ? 'rounded-t-xl' : 'rounded-xl'} bg-white text-gray-700`}>
        <div className="text-md font-bold">First Owner Information</div>
        <div className="flex flex-row">
          <div className="mt-1">{isFieldVisible ? 'Show Detail' : 'Hide Detail'}</div>
          <div>
            <FormControlLabel
              control={<IOSSwitch sx={{ ml: 3 }} checked={isFieldVisible} onChange={(e) => setIsFieldVisible(e.target.checked)} />}
            />
          </div>
        </div>
      </div>

      <Collapse in={isFieldVisible} timeout={500} unmountOnExit>
        <div className="flex flex-col bg-white p-4 gap-4 rounded-b-xl text-gray-900">
          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="ownerFirstName"
              label="Owner First Name"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerFirstName || ''}
              onChange={(e) => handleChange('ownerFirstName', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="ownerMiddleName"
              label="Owner Middle Name"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerMiddleName || ''}
              onChange={(e) => handleChange('ownerMiddleName', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="ownerLastName"
              label="Owner Last Name"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerLastName || ''}
              onChange={(e) => handleChange('ownerLastName', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="ownerPhoneNumber"
              label="Owner Phone Number"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerPhoneNumber || ''}
              onChange={(e) => handleChange('ownerPhoneNumber', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="ownerCompanyName"
              label="Owner Company Name"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerCompanyName || ''}
              onChange={(e) => handleChange('ownerCompanyName', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="ownerAddressLine1"
              label="Owner Address Line 1"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerAddressLine1 || ''}
              onChange={(e) => handleChange('ownerAddressLine1', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="ownerAddressLine2"
              label="Owner Address Line 2"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerAddressLine2 || ''}
              onChange={(e) => handleChange('ownerAddressLine2', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="ownerCity"
              label="Owner City"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerCity || ''}
              onChange={(e) => handleChange('ownerCity', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="ownerState"
              label="Owner State"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerState || ''}
              onChange={(e) => handleChange('ownerState', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="ownerCountry"
              label="Owner County"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerCountry || ''}
              onChange={(e) => handleChange('ownerCountry', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="ownerZip"
              label="Owner Zip"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerZip || ''}
              onChange={(e) => handleChange('ownerZip', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="ownerDob"
              label="Owner Date of Birth"
              type="date"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              className="flex-1"
              value={firstOwnerInfo?.ownerDob || ''}
              onChange={(e) => handleChange('ownerDob', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="ownerSsn"
              label="Owner SSN"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerSsn || ''}
              onChange={(e) => handleChange('ownerSsn', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="ownerLicenseNumber"
              label="Owner Driver's License Number"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerLicenseNumber || ''}
              onChange={(e) => handleChange('ownerLicenseNumber', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="ownerLicenseState"
              label="Owner Driver's License State"
              variant="outlined"
              className="flex-1"
              value={firstOwnerInfo?.ownerLicenseState || ''}
              onChange={(e) => handleChange('ownerLicenseState', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default FirstOwnerInformation;
